/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-video': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.125 16.25H2.5c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h10.625c.69 0 1.25.56 1.25 1.25v2.537l3.387-2.418a.625.625 0 01.988.506v8.75a.625.625 0 01-.988.506l-3.387-2.418V15c0 .69-.56 1.25-1.25 1.25zM2.5 5v10h10.625v-3.75a.625.625 0 01.988-.506l3.387 2.418V6.837l-3.387 2.42a.625.625 0 01-.988-.507V5H2.5z"/>'
  }
})
